<script>
    export default {
        props: {
            productId: null
        },
        mounted() {
            this.loadEditorUsers();
        },
        data() {
            return {
                editorUsers: [],
                selectedEditorUser: 0,
            }
        },
        methods: {
            loadEditorUsers() {
                axios.get(`${Scoop.baseUrl}/productTextEditorUsers?productId=${this.productId}`).then(res => {
                    this.editorUsers = res.data.users;
                    this.selectedEditorUser = res.data.selectedUser;
                })
            },
            storeEditorUsers() {
                axios.post(`${Scoop.baseUrl}/productTextEditorUsers`, {
                    productId: this.productId,
                    userId: this.selectedEditorUser
                }).then(res => {
                    if (res.data.selectedUser !== '0') {
                        toastr.success('Texter wurde zugeordnet.');
                    } else {
                        toastr.success('Texter wurde entfernt.');
                    }
                    this.selectedEditorUser = res.data.selectedUser;
                })
            },
        }
    }
</script>

<template>
    <div>
        <select class="form-control" style="margin-top: 11px" v-model="selectedEditorUser" @change="storeEditorUsers">
            <option value="0">Kein Texter</option>
            <option :value="editor.id" v-for="editor in editorUsers">{{ editor.fullName }}</option>
        </select>
    </div>
</template>
